import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import { List } from 'immutable';

import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import Icon from '@material-ui/core/Icon';

const AddShoppingCartDialog = props => {
    const { t } = useTranslation();
    const [shoppingCart, setShoppingCart] = useState(List())
    const { open, onClose, addShoppingCart, allMemberWine } = props
    
    const onEnter = () => {
        let data = props.shippingCart
            .get('list')
            .reduce((acc, curr) => {
                const memberWineIds = curr
                    .get('storageOrderItems')
                    .map(memberWine => memberWine.get('id'))
                return acc.concat(memberWineIds)
            }, List())
            .concat(shoppingCart)
            .toJS()
        addShoppingCart(data)
        onClose()
    }
    
    const addWine = (wineId) => {
        setShoppingCart(shoppingCart.push(wineId))
    }
    
    const removeWine = (wineId) => {
        setShoppingCart(shoppingCart.filter(wine => wine !== wineId))
    }
    
    const selectAll = () => {
        const allWineId = allMemberWine.map(wine => wine.id)
        setShoppingCart(List(allWineId))
    }
    
    const removeAll = () => {
        setShoppingCart(List())
    }

    return (
        <Dialog
            className="add-shopping-cart"
            open={open}
            onClose={onClose}
            fullWidth
            scroll="paper"
        >
            <DialogTitle>
                <Grid container justify="space-between" alignItems="center">
                    <Typography className="title" variant="h1">
                        {t('add_to_shipping_cart')}
                    </Typography>
                    <CloseIcon className="dialog-close pointer" onClick={onClose} />
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Grid container alignItems="center" className="action">
                    <Button variant="contained" size="small" color="primary"
                        onClick={selectAll}
                    >
                        <Icon>add</Icon>{t('select_all')}
                    </Button>
                    <Button variant="outlined" size="small"
                        onClick={removeAll}
                    >
                        <Icon>remove</Icon>{t('remove_all')}
                    </Button>
                </Grid>
                <Grid container className="storage-wine" spacing={2}>
                    {allMemberWine.map(wine => {
                        const wineId = wine.id
                        const isAdded = shoppingCart.includes(wineId)
                        return (
                            <Grid key={wine.code} item container xs={4} direction="column">
                                <Grid item
                                    className="wine-img"
                                    style={{
                                        backgroundImage: `url(${wine.imageUrl})`,
                                    }}
                                />
                                <Grid item>
                                    <Typography className="text-center text-grey">
                                        {wine.code}
                                    </Typography>
                                </Grid>
                                <Grid item className="text-center button">
                                    {isAdded ?
                                        <Button variant="outlined" size="small"
                                            onClick={() => removeWine(wineId)}
                                        >
                                            <Icon>remove</Icon>{t('remove')}
                                        </Button>
                                        :
                                        <Button variant="contained" size="small" color="primary"
                                            onClick={() => addWine(wineId)}
                                        >
                                            <Icon>add</Icon>{t('add')}
                                        </Button>
                                    }
                                    
                                </Grid>
                            </Grid>
                        )
                    })}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container justify="space-between" alignItems="center">
                    <Typography className="text-grey">
                        已選 {shoppingCart.size} 瓶酒
                    </Typography>
                    <Button color="primary" variant="contained" onClick={onEnter}>
                        {t('comfirm')}
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
  )
}

export default AddShoppingCartDialog